import React from 'react'
import { Box, Typography } from 'components'
import { Chip } from '@material-ui/core'

export function CityProvinceFilter({ filterState: state, setFilterState: setState }) {
  const { market } = state
  
  // Use the existing cities data from the parent component which is passed to FilterBar
  // For now, using static cities for demo
  const cityProvinceTags = [
    { id: 'toronto', name: 'Toronto' },
    { id: 'ottawa', name: 'Ottawa' },
    { id: 'montreal', name: 'Montreal' },
    { id: 'vancouver', name: 'Vancouver' },
    { id: 'ontario', name: 'Ontario' },
    { id: 'quebec', name: 'Quebec' },
    { id: 'bc', name: 'British Columbia' }
  ]

  const onCityProvinceTagChange = (tag) => {
    // The market property has a structure with cityId
    setState({
      ...state,
      market: {
        ...state.market,
        cityId: tag.id,
        cityName: tag.name
      }
    })
  }
  
  return (
    <Box py={1.5} flex={1} flexVariant="space-between align-center" minHeight="fit-content">
      <Box display="flex" alignItems="center" flex={1} flexDirection="column">
        <Typography variant="subtitle1" style={{ marginBottom: '10px' }}>City/Province</Typography>
        <Box
          display="flex"
          alignItems="center"
          flex={1}
          flexDirection="row"
          flexWrap="wrap"
          width="30dvw">
          {cityProvinceTags.map((tag) => {
            const isSelected = market && market.cityId === tag.id
            return (
              <Chip 
                label={tag.name} 
                key={tag.id} 
                style={{ margin: 2 }} 
                variant={isSelected ? 'default' : 'outlined'} 
                color='primary'
                onClick={() => onCityProvinceTagChange(tag)} 
              />
            )
          })}
        </Box>
      </Box>
    </Box>
  )
}
